<template>
  <div
    @click="$emit('click')"
  >
    <img
      class="img-fluid image-transition"
      :width="`${width}px`"
      :height="`${height}px`"
      :src="`${aws}${icon}.svg`"
    >
  </div>
</template>
<script>
export default {
  name: 'CustomIcon',
  props: {
    icon: {
      type: String,
      required: true,
      default: '',
    },
    folder: {
      type: String,
      default: 'common/svg',
    },
    width: {
      type: [Number, String],
      default: 16,
    },
    height: {
      type: [Number, String],
      default: 16,
    },
  },
  emits: ['click'],
  computed: {
    aws() {
      return `${import.meta.env.VITE_AWS_STATIC}/${this.folder}/`;
    },
  },
};
</script>
<style scoped>
.image-transition {
  transition: background-image 0.2s ease-in-out;
}
</style>
